import { FC } from 'react';

export const ResetPasswordBackground: FC = () => {
  return (
    <div className='relative h-screen w-full rounded-es-[10dvh] rounded-ss-[10dvh] bg-[#fff]'>
      <img className='absolute bottom-0 left-0 top-[10px] min-h-full w-full object-cover' src='/postel_rectangle.svg' />
    </div>
  );
};
